import React, {Component} from 'react';
import * as echarts from 'echarts';
import geo from '../json/xian.json'
import {right} from "@antv/g2plot/lib/plots/sankey/sankey";

class Datasellkind extends Component {
    constructor(props) {
        super(props);
        let option = {
            backgroundColor:'rgba(128, 128, 128, 0)',
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                x: 'center',
                y: 'top',
                orient: 'horizontal'
            },
            series: [
                {
                    name: 'Nightingale Chart',
                    type: 'pie',
                    radius: [50, 200],
                    center: ['50%', '60%'],
                    roseType: 'area',
                    itemStyle: {
                        borderRadius: 10
                    },
                    label: {
                        formatter: '{c}',
                    },
                    data: [
                        { value: 130443.74, name: '水泥P.O42.5级 散' },
                        { value: 1839.50, name: '水泥P.O42.5级 袋' },
                        { value: 9413.62, name: '水泥P.O42.5级(铁路) 散' },
                        { value: 3220.84, name: '水泥P.O42.5级(缓凝) 散' },
                        { value: 450.40, name: '水泥P.O42.5级(低碱) 散' },
                        { value: 4930.50, name: '水泥M32.5级袋' },
                        { value: 131.06, name: '水泥M32.5级（缓凝） 散' },
                        { value: 901.12, name: '水泥M32.5级 散' },
                        { value: 2481.96, name: '矿粉S95' }
                    ]
                }
            ]
        };
        this.state = {
            option: option,
            array: []
        };
    }

    componentDidMount() {
        fetch("http://pd.pokemonbye.com:8087/api/getsellmonth")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    this.setState({
                        isLoaded: true,
                        array: array
                    });
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        let option = this.state.option;
        let array = this.state.array;
        const data = [];

        for (var i = 0; i < array.length; i++) {

            data.push(
                {value:array[i].sum, name:array[i].stockname}
            );
        }
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('datasellkind'),'dark');
        //点击事件
        myChart.on('click', function (params) {
            //window.open('/list?area=' + encodeURIComponent(params.data.id), '_self');
        });
        myChart.setOption((option));
        option && myChart.setOption(option);
        myChart.setOption({
            series: [{
                data
            }
            ]
        });
    }

    render() {
        return (
            <div id="datasellkind" className="histogramline"></div>
        )
    }
}

export default Datasellkind;
